import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BicButtonComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';

/**
 * Erklärt, warum nur ein KI-Modell zur Auswahl steht, und führt zum Enterprise-Angebot.
 *
 * Bewusst ohne eigene Navigation: welche Seite „Zum Angebot" öffnet, entscheidet der Aufrufer –
 * der Dialog meldet nur, dass der Nutzer das Angebot sehen will.
 */
@Component({
  selector: 'app-ai-model-enterprise-popup',
  standalone: true,
  imports: [BicPopupComponent, BicButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ai-model-enterprise-popup.component.html',
})
export class AiModelEnterprisePopupComponent {
  /** Das Modell, das dem Nutzer aktuell zur Verfügung steht. */
  @Input() currentModel = '';

  @Output() closed = new EventEmitter<void>();
  @Output() offerRequested = new EventEmitter<void>();
}
